/** Page turning for the horizontal score layout (pure, unit-tested). */

/** The page turns when the cursor passes this share of the visible width. */
export const PAGE_TURN_AT = 0.8;
/** After a turn, the cursor starts this far from the left edge (a little music before it stays in view). */
export const PAGE_LEFT_MARGIN_PX = 40;

/**
 * Where the score box should scroll so the cursor stays readable, or null to stay put.
 * The cursor moves freely until it passes 80 % of the view; then the view moves one "page" so the
 * cursor is near the left edge again. A cursor left of the view (a repeat or a new start bar)
 * is brought back the same way.
 *
 * @param cursorX cursor position relative to the left edge of the visible area, in px
 */
export function pageTurnScroll(cursorX: number, viewWidth: number, scrollLeft: number): number | null {
  const inView = cursorX >= PAGE_LEFT_MARGIN_PX / 2 && cursorX <= viewWidth * PAGE_TURN_AT;
  if (inView) return null;
  const target = Math.max(0, Math.round(scrollLeft + cursorX - PAGE_LEFT_MARGIN_PX));
  return target === Math.round(scrollLeft) ? null : target;
}
